// extracted by mini-css-extract-plugin
export default {"kc_document_preview_content_container":"KcDocumentView_kc_document_preview_content_container__jWC9q"};